import React from 'react'

import { Container } from '../../components/Bootstrap'
import { Bar } from '../../components/Charts'
import Hero from '../../components/Hero'
import Layout from '../../components/Layout'
import Navigation from '../../components/Navigation'
import Summary from '../../components/Summary'

import { bold } from '../../styles'

const PartnerSix = () => (
  <Layout>
    <Hero>
      <h1>Question 6</h1>
      <p className={bold}>In your opinion, what should the Centre for Independent Living Toronto (CILT) improve on?</p>
    </Hero>
    <Container>
      <Navigation prev="/partners/5" next="/partners/7" />
      <Bar
        data={{
          labels: [ 'Communications and Branding', 'Community Engagement', 'Fostering Social Equity', 'Program Development', 'Resource Development', 'Strategic Collaborations', 'Mobilizing consumers to influence accessibility policy' ],
          series: [ [ 2.9, 5.2, 4.3, 4.8, 3.4, 3.7, 4.0 ] ]
        }}
        options={{
          axisY: {
            offset: 60,
            scaleMinSpace: 30,
            onlyInteger: true,
          },
          axisX: {
            offset: 100,
            scaleMinSpace: 60,
          },
          height: '500px',
          width: '100%',
          high: 6,
          seriesBarDistance: 4
        }}
        caption="In your opinion, what should the Centre for Independent Living Toronto (CILT) improve on?"
      />
	  <Summary>The graph shows that survey respondents think that CILT could improve on (in descending order) Community Engagement, Program Development, Fostering Social Equity, Mobilizing consumers to influence accessibility policy, Strategic Collaborations, Resource Development and Communications and Branding.</Summary>
    </Container>
  </Layout>
)

export default PartnerSix
